import { OfferConditionsTable } from './OfferConditionsTable';
export { OfferConditionsTable } from './OfferConditionsTable';
export { CreateOfferConditionPage } from './CreateOfferConditionPage';
export { UpdateOfferConditionPage } from './UpdateOfferConditionPage';
export default OfferConditionsTable;
